module.exports = __webpack_public_path__ + "img/gamesdk10.2880dc6.png";